// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"234":"82dafaee","338":"8c1ecb40"}[chunkId] + ".chunk.css";
};